module.exports = __webpack_public_path__ + "img/keyboard_key_1.d765094c.png";